import jQuery from "jquery";

import * as bootstrap from "bootstrap";
//import "slick-carousel";
import "jquery-mapael";
import "./world_countries.min";

import mixitup from "mixitup";

const mixer = mixitup("#mix-container", {
  selectors: {
    target: ".mix",
  },
  animation: {
    duration: 300,
  },
});

// Filter on dropdown change
document
  .getElementById("filter-select")
  .addEventListener("change", function () {
    const value = this.value;
    mixer.filter(value === "all" ? "all" : value);
  });

map = () => {
  jQuery(function () {
    jQuery(".mapcontainer").mapael({
      map: {
        name: "world_countries",
        defaultArea: {
          attrs: {
            fill: "#6D3C9A",
            stroke: "#380169",
          },
          attrsHover: {
            fill: "#6D3C9A",
          },
          text: {
            attrs: {
              fill: "#505444",
            },
            attrsHover: {
              fill: "#000",
            },
          },
        },
        defaultPlot: {
          attrs: {
            fill: "#ffffff",
            stroke: "#240045",
            "stroke-width": 3,
            opacity: 1,
          },
          attrsHover: {
            opacity: 1,
            fill: "#ffffff",
          },
          text: {
            attrs: {
              fill: "#ffffff",
            },
            attrsHover: {
              fill: "#000",
            },
          },
        },
      },
      areas: {
        US: {
          /*tooltip: {
            content: "<strong>France</strong><br>Population: 67 million",
          },*/
          attrs: {
            fill: "#C9A2FF", // Green color fill
            //stroke: '#F6EDFE', // White border
            // 'stroke-width': 1
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        UAE: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        SA: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        SG: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        CN: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        RU: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        QA: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        FR: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        DE: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        DE: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        ES: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        IT: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
        JP: {
          attrs: {
            fill: "#C9A2FF",
          },
          attrsHover: {
            fill: "#C9A2FF",
          },
        },
      },
      plots: {
        riyadh: {
          type: "circle",
          size: 20,
          latitude: 24.7136,
          longitude: 46.6753,
          tooltip: { content: "Riyadh" },
        },
        dubai: {
          type: "circle",
          size: 16,
          latitude: 25.2048,
          longitude: 55.2708,
          tooltip: { content: "Dubai" },
        },
        houston: {
          type: "circle",
          size: 24,
          latitude: 29.760427,
          longitude: -95.369804,
          tooltip: { content: "Houston" },
        },
        los_angeles: {
          type: "circle",
          size: 24,
          latitude: 34.052235,
          longitude: -118.243683,
          tooltip: { content: "Los Angeles" },
          //attrs: { fill: '#ffffff' }
        },
        new_york: {
          type: "circle",
          size: 24,
          latitude: 40.712776,
          longitude: -74.005974,
          tooltip: { content: "New York" },
          //attrs: { fill: '#ffffff' }
        },
        washington_dc: {
          type: "circle",
          size: 24,
          latitude: 38.907192,
          longitude: -77.036873,
          tooltip: { content: "Washington DC" },
          //attrs: { fill: '#ffffff' }
        },
        atlanta: {
          type: "circle",
          size: 24,
          latitude: 33.7501,
          longitude: 84.3885,
          tooltip: { content: "Atlanta" },
          //attrs: { fill: '#ffffff' }
        },
        dallas: {
          type: "circle",
          size: 24,
          latitude: 32.7767,
          longitude: 96.797,
          tooltip: { content: "Dallas" },
          //attrs: { fill: '#ffffff' }
        },
        london: {
          type: "circle",
          size: 24,
          latitude: 51.507351,
          longitude: -0.127758,
          tooltip: { content: "London" },
          //attrs: { fill: '#ffffff' }
        },
        paris: {
          type: "circle",
          size: 24,
          latitude: 48.856613,
          longitude: 2.352222,
          tooltip: { content: "Paris" },
          // attrs: { fill: '#ffffff' }
        },
        bay_area: {
          type: "circle",
          size: 24,
          latitude: 37.8272,
          longitude: 122.2913,
          tooltip: { content: "Bay Area (California)" },
          // attrs: { fill: '#ffffff' }
        },
        moscow: {
          type: "circle",
          size: 24,
          latitude: 55.755825,
          longitude: 37.617298,
          tooltip: { content: "Moscow" },
          // attrs: { fill: '#ffffff' }
        },
        beijing: {
          type: "circle",
          size: 24,
          latitude: 39.9042,
          longitude: 116.4074,
          tooltip: { content: "Beijing" },
          // attrs: { fill: '#ffffff' }
        },
        france: {
          type: "circle",
          size: 24,
          latitude: 46.2276,
          longitude: 2.2137,
          tooltip: { content: "France" },
          // attrs: { fill: '#ffffff' }
        },
        shenzhen: {
          type: "circle",
          size: 24,
          latitude: 22.5429,
          longitude: 114.0596,
          tooltip: { content: "Shenzhen" },
          // attrs: { fill: '#ffffff' }
        },
        doha: {
          type: "circle",
          size: 24,
          latitude: 5.2854,
          longitude: 51.531,
          tooltip: { content: "Doha" },
          // attrs: { fill: '#ffffff' }
        },
        germany: {
          type: "circle",
          size: 24,
          latitude: 51.1657,
          longitude: 10.4515,
          tooltip: { content: "Germany" },
          // attrs: { fill: '#ffffff' }
        },
        spain: {
          type: "circle",
          size: 24,
          latitude: 40.4637,
          longitude: 3.7492,
          tooltip: { content: "Spain" },
          // attrs: { fill: '#ffffff' }
        },
        italy: {
          type: "circle",
          size: 24,
          latitude: 41.8719,
          longitude: 12.5674,
          tooltip: { content: "Italy" },
          // attrs: { fill: '#ffffff' }
        },
        japan: {
          type: "circle",
          size: 24,
          latitude: 36.2048,
          longitude: 138.2529,
          tooltip: { content: "Japan" },
          // attrs: { fill: '#ffffff' }
        },
      },
    });
  });
};

map();

var x, i, j, l, ll, selElmnt, a, b, c;
var status = false;
/*look for any elements with the class "custom-select":*/
x = document.getElementsByClassName("custom-select");
l = x.length;
for (i = 0; i < l; i++) {
  selElmnt = x[i].getElementsByTagName("select")[0];
  ll = selElmnt.length;
  /*for each element, create a new DIV that will act as the selected item:*/
  a = document.createElement("DIV");
  a.setAttribute("class", "select-selected");
  a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  x[i].appendChild(a);
  /*for each element, create a new DIV that will contain the option list:*/
  b = document.createElement("DIV");
  b.setAttribute("class", "select-items select-hide");
  for (j = 1; j < ll; j++) {
    /*for each option in the original select element,
    create a new DIV that will act as an option item:*/
    c = document.createElement("DIV");
    c.innerHTML = selElmnt.options[j].innerHTML;
    c.setAttribute("data-value", selElmnt.options[j].value);
    c.addEventListener("click", function (e) {
      /*when an item is clicked, update the original select box,
        and the selected item:*/
      var y, i, k, s, h, sl, yl;
      s = this.parentNode.parentNode.getElementsByTagName("select")[0];
      sl = s.length;
      h = this.parentNode.previousSibling;
      for (i = 0; i < sl; i++) {
        if (s.options[i].innerHTML == this.innerHTML) {
          s.selectedIndex = i;
          h.innerHTML = this.innerHTML;
          y = this.parentNode.getElementsByClassName("same-as-selected");
          yl = y.length;
          for (k = 0; k < yl; k++) {
            y[k].removeAttribute("class");
          }
          this.setAttribute("class", "same-as-selected");
          break;
        }
      }
      h.click();
    });
    b.appendChild(c);
  }
  x[i].appendChild(b);
  a.addEventListener("click", function (e) {
    /*when the select box is clicked, close any other select boxes,
      and open/close the current select box:*/
    e.stopPropagation();
    closeAllSelect(this);
    var ele = e;
    this.nextSibling.classList.toggle("select-hide");
    //this.classList.toggle("select-arrow-active");
    if (this.classList.contains("select-arrow-active")) {
      this.classList.toggle("select-arrow-active");
    } else {
      //this.classList.add("select-arrow-active");
      status = true;
      this.classList.toggle("select-arrow-active");
    }
  });
}
function closeAllSelect(elmnt) {
  /*a function that will close all select boxes in the document,
  except the current select box:*/
  var x,
    y,
    i,
    xl,
    yl,
    arrNo = [];
  x = document.getElementsByClassName("select-items");
  y = document.getElementsByClassName("select-selected");
  xl = x.length;
  yl = y.length;
  for (i = 0; i < yl; i++) {
    if (elmnt == y[i]) {
      arrNo.push(i);
    } else {
      y[i].classList.remove("select-arrow-active");
    }
  }
  for (i = 0; i < xl; i++) {
    if (arrNo.indexOf(i)) {
      x[i].classList.add("select-hide");
    }
  }
}
/*if the user clicks anywhere outside the select box,
then close all select boxes:*/
document.addEventListener("click", function (e) {
  closeAllSelect();

  if (status == true) {
    const selectElement = document.getElementById("filter-select");
    selectElement.value = e.target.dataset.value; // Change the value
    selectElement.dispatchEvent(new Event("change"));
    
    status = false;
  }
});
